/**
 * Tipos de Aviso suportados pelo backend.
 *
 * Reflete o enum Kotlin `br.com.avati.avat.valueobjects.TipoAviso`.
 * Cada tipo controla quais campos adicionais do aviso ficam obrigatorios
 * (urlVideo, urlLink, textoDialogo, numeroWhatsapp, perfilInstagram, etc.).
 */
export enum TipoAviso {
  VIDEO = 'VIDEO',
  LINK = 'LINK',
  DIALOGO = 'DIALOGO',
  CHAT_WHATSAPP = 'CHAT_WHATSAPP',
  PERFIL_INSTAGRAM = 'PERFIL_INSTAGRAM',
  NADA_A_FAZER = 'NADA_A_FAZER',
  TUTORIAL = 'TUTORIAL',
}
